import { useState, useMemo } from 'react'

import { useDisclosure } from '@chakra-ui/react'
import { fetchMFAPreference, setUpTOTP } from 'aws-amplify/auth'
import useSWR from 'swr'

export const useMfa = () => {
  const [QRSecretKey, setQRSecretKey] = useState('')

  const { data: mfaPreference } = useSWR('mfaPreference', async () => {
    return await fetchMFAPreference()
  })

  const isActiveMta = useMemo(() => {
    return mfaPreference?.enabled?.includes('TOTP') ?? false
  }, [mfaPreference?.enabled])

  const {
    isOpen: isOpenMfaModal,
    onOpen: openMfaModal,
    onClose: closeMfaModal,
  } = useDisclosure()

  const handleClickMfaMenu = async () => {
    if (!isActiveMta) {
      const setupOut = await setUpTOTP()
      setQRSecretKey(setupOut.sharedSecret)
    }

    openMfaModal()
  }

  return {
    QRSecretKey,
    isActiveMta,
    isOpenMfaModal,
    closeMfaModal,
    handleClickMfaMenu,
  }
}
